import { Component, OnInit } from '@angular/core';
import { BaseService } from './../../_services/base.service';
import { Adal5Service } from 'adal-angular5';
import { ConfigService } from './../../_services/config.service';
import { environment } from '../../../environments/environment';
import { BaseComponent } from '../shared/baseComponent';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends BaseComponent implements OnInit {
  environmentName = environment.envName;
  
  maps: any;
  constructor(public adalService: Adal5Service , private baseService: BaseService) { 
    super(adalService);
  }

  ngOnInit() {
    // console.log(this.adalService);
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/components/home/home.component.ts